import React, { useMemo } from 'react';
import OrderContentFelge from './OrderContentFelge';
import OrderContentProduct from './OrderContentProduct';
import OrderContentReifen from './OrderContentReifen';
import OrderContentService from './OrderContentService';

function OrderContent({ product, markenStandort, orderId }) {
    const images = useMemo(() => {
        const blobUrl = product?.isOwnArticle ? '' : 'https://techno-images.s3.eu-central-1.amazonaws.com/images/articles/';
        const bildUrl = product?.isOwnArticle ? '' : 'https://www.tibsonline.de/AddvMultimedia/';
        let images = [];

        if (product?.blobdatei) {
            images.push(blobUrl + product?.blobdatei);
        } else if (product?.bilddatei) {
            images.push(bildUrl + product?.bilddatei);
        }
        if (product?.blobdatei2) {
            images.push(blobUrl + product?.blobdatei2);
        } else if (product?.bilddatei2) {
            images.push(bildUrl + product?.bilddatei2);
        }
        if (product?.blobdatei3) {
            images.push(blobUrl + product?.blobdatei3);
        } else if (product?.bilddatei3) {
            images.push(bildUrl + product?.bilddatei3);
        }

        if (!images.length && product?.images) {
            images = product?.images.map(image => image)// `https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${image.name}`);
        }

        return images;
    }, [product]);

    const currentOrderState = useMemo(() => {
        return product?.orderStates.find(state => state?.status === product?.orderStatus);
    }, [product]);

    const frontEndOrderActions = useMemo(() => {
        return currentOrderState?.orderActions?.filter(action => !action?.isBackend && action.requiresModal) || [];
    }, [currentOrderState]);

    const showRetoureLink = !['initiated', 'cancelled', 'completedProductExchange', 'changeAppointment', 'reversed', 'refunded'].includes(
        product.orderStatus
    );

    switch (product.elementType) {
        case 'felge':
            return (
                <OrderContentFelge
                    currentOrderState={currentOrderState}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                />
            );
        case 'reifen':
            return (
                <OrderContentReifen
                    currentOrderState={currentOrderState}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                />
            );
        case 'service':
            return (
                <OrderContentService
                    currentOrderState={currentOrderState}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                />
            );
        case 'product':
            return (
                <OrderContentProduct
                    currentOrderState={currentOrderState}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                />
            );
        default:
            return (
                <OrderContentProduct
                    currentOrderState={currentOrderState}
                    frontEndOrderActions={frontEndOrderActions}
                    images={images}
                    orderId={orderId}
                    product={product}
                    markenStandort={markenStandort}
                    showRetoureLink={showRetoureLink}
                />
            );
    }
}

export default OrderContent;
